import util from "../utils/util";
import axiosp from "../utils/axiosp";
import ControlCenterRequest from "../utils/axiosp";

import qs from "qs";
import axios from "axios";

function GetCredit() {
  return Promise.all([
    axiosp.reqPost("User/GetCredit"),
    axiosp.reqPost("ReceivablesItem/GetPrePaymentStatistics", {
      CustomerID: util.getStoObj("allinfo").ADS_UserId,
    }),
  ]).then((res) => {
    var res1 = res[0].Data || {};
    var res2 = res[1].Data || {};

    return {
      Creditline: res1.Creditline, //授信总额度
      HaveUsedLimit: res1.HaveUsedLimit, //已用额度
      HasCreditMoney: res1.RemainingUndrawn || 0, //额度支付金额
      HasRechargeMoney: res2.Amount, //预充值金额
      RechargeMoneyID: res2.Id, //预充值金额主键ID
      PendingApproveAmount: res2.PendingApproveAmount, //待审核金额
    };
  });
}

function getDMSCode() {
  let urlQuery = util.getStoObj("urlQuery");

  if (urlQuery && urlQuery.Eshop_DMSCode) {
    return urlQuery.Eshop_DMSCode;
  } else {
    return "";
  }
}

function getMobile() {
  let allinfo = util.getStoObj("allinfo");

  if (allinfo && allinfo.LegalPersonPhone) {
    return allinfo.LegalPersonPhone;
  } else {
    return "";
  }
}

function getShopCode() {
  let urlQuery = util.getStoObj("urlQuery");

  if (urlQuery && urlQuery.Eshop_ShopCode) {
    return urlQuery.Eshop_ShopCode;
  } else {
    return "";
  }
}

// 登录汽配通
function loginQPT() {
  let url = "/Login/LoginEShop";

  return axios
    .request({
      url,
      headers: {
        "content-type": "application/x-www-form-urlencoded",
      },
      method: "POST",
      data: qs.stringify({
        DMSCode: getDMSCode(),
        ShopCode: getShopCode(),
      }),
    })
    .then(({ data }) => {
      //将token全局缓存
      sessionStorage.setItem("QPT_UserToken", data.Data.Token || "");
      return data;
    });
}

// /User/VerifyCustomerAuditStatus
// 获取申请权限
//0	Int	默认值(未知状态)
//1	Int	待申请
//2	Int	审核中
//3	Int	审核通过
//4	Int	否决
function VerifyCustomerAuditStatus() {
  let { Eshop_Mobile, Eshop_DMSCode, Eshop_ShopCode } = util.getStoObj("urlQuery") || {};

  return axiosp.reqPost("/User/VerifyCustomerAuditStatus", {
    DMSCode: Eshop_DMSCode,
    ShopCode: Eshop_ShopCode,
    Mobile: Eshop_Mobile,
  });
}

function getImgUrl() {
  let { Eshop_Mobile, Eshop_DMSCode, Eshop_ShopCode } = util.getStoObj("urlQuery") || {};

  return axiosp.reqPost("/User/GetEnterpriseInfoAPI", {
    DMSCode: Eshop_DMSCode,
    ShopCode: Eshop_ShopCode,
  });
}

/**
 *
 */
function Eshop_login() {
  let data = util.getStoObj("urlQuery");
  // that.loadShow = true;
  // if (!util.getStoObj('allinfo')) {
  return axiosp.post("Authorize/LoginByEshopApp", {
    ...data,
    //START车店互联版API的代码
    // Eshop_DMSCode: that.Eshop_DMSCode,
    // Eshop_ShopCode: that.Eshop_ShopCode,
    // UserType: that.UserType,
    // Eshop_Name: that.Eshop_Name,
    // Eshop_Company: that.Eshop_Company,
    // Eshop_Mobile: that.Eshop_Mobile,
    // Eshop_UserToken: that.Eshop_UserToken,
    // PlatformType: that.PlatformType,
    //END车店互联版API的代码
  });
}

/**
 *   正式域名：  apscmcenter.eshop1001.cn
 *   测试域名：  apscmcentertest.51autoshop.com
 *    URL： ApiEnterprise/GetErpDomainNameAll
 * 根据DmcCode获取接口域名
 */
function GetErpDomainNameAll(DMSCode) {
  console.log(DMSCode);
  let data = {
    code: DMSCode,
  };
  console.log(data);
  return axiosp.ControlCenterRequest("ApiEnterprise/GetErpDomainNameAll", data);
  // return  new Promise((resolve, reject) => {
  // 	resolve(res)
  // })
}

/**
 * 额度支付
 *
 * 参数名|描述|备注
 * -|-|-
 * OrderId|订单ID |
 * OrderType|订单类型 |
 * PaymentMethodList |支付明细(json字符串)| Method 支付方式  Amount	金额
 */
function PayCredit(params) {
  let { OrderId, OrderType, PaymentMethodList } = params;
  let data = {
    OrderId,
    OrderType,
    PaymentMethodList: JSON.stringify(PaymentMethodList),
  };
  return axiosp.reqPost("/ReceivablesItem/Payment", data);
}
/**
 * 支付
 *
 * 参数名| 描述 | 备注
 * -|-|-
 * RepaymentOrderId:    |还款单id|
 * ADS_OrderId：        |订单id|
 * Pay_Platform：       |支付类型|
 * PayAmount：          |支付金额|
 * OrderType：         |订单类型|
 */
function PayMoney(params) {
  let { Eshop_Mobile, RepaymentOrderId, ADS_OrderId, Pay_Platform, PayAmount, OrderType} = params;
  let data = {
    Eshop_Mobile,
    RepaymentOrderId,
    OrderType,
    ADS_OrderId,
    Pay_Platform,
    PayAmount,
    ...util.getStoObj("Eshop_login"),
  };
  return axiosp.payforReqPost("Ca_AcProducts/PayRepaymentOrder", data);
}
/**
 * 创建订单
 *
 * 参数名| 描述 | 备注
 * -|-|-
 * UserId	                  |用户id|       默认从本地获取
 * AddressId	              |收货地址Id|
 * ProductDetails	          |产品明细信息|(json对象字符串)|
 * OrderType	              |订单来源类型（6：订货平台，8：订货促销活动）|           // 默认 6
 * TotalAmount	            |单据总金额|
 * IsImmediatePurchase	    |是否立即购买|(是：1，否：0)默认0                       // h5 默认为 0
 * VehicleTypeId	          |车型ID|                                              // h5 现在没有车型
 * Remark	                  |备注|                                                // h5 现在没有备注
 * WarehouseId	            |出库仓库Id（没有传值则取默认仓库）|                    // h5 现在没有仓库选择
 * IsOnlineOrder	          |是否在线订货(不传data只显示id，传了data返回对象数据)|   // 默认为true
 */
function CreatOrder({
  AddressId,
  ProductDetails,
  VehicleTypeId,
  TotalAmount,
  IsImmediatePurchase,
  isActivity,
  MallActivityManagementId,
  Remark,
  WarehouseId,
  IsType
}) {
  let data = {
    UserId: util.getStoObj("allinfo").UserId, // 从本都获取信息
    AddressId,
    ProductDetails,
    TotalAmount,
    VehicleTypeId,
    WarehouseId,
    IsType,
    //CustomerID: 110655,
    IsImmediatePurchase: 1, //1为立即购买，不会影响订货H5的购物车
    // VehicleTypeId,
    Remark,
    // WarehouseId,
    OrderType: 13, //8活动订单 6为订货助手  13 智能报价
    IsOnlineOrder: true,
  };
  if (MallActivityManagementId) {
    data.MallActivityManagementId = MallActivityManagementId;
  }
  return axiosp.reqPost("/Order/AddOrder", data);
}

function CreateVirtualAdvanceCollection(MallActivityManagementId) {
  return axiosp.reqPost("/MallActivity/CreateVirtualAdvanceCollection", { MallActivityManagementId });
}

function getOrderDetail({ UserId, OrderId, Type }) {
  return axiosp.reqPost("Order/GetOrderDetailsByType", {
    UserId,
    OrderId,
    Type,
  });
}
/*********
 * 活动列表表
 * 参数名 | 描述 | 备注
 * -|-|-
 * Keyword 搜索关键词
 * pageNo  页码
 * pageSize 每页显示
 * type 活动类型
 *
 * ********* */
function getActivity({ Keyword, Type, pageNo = 0, pageSize = 300 }) {
  return axiosp.reqPost(`MallActivity/GetActivitiesInvolved`, {
    pageNo,
    pageSize,
    Keyword,
    Type,
  });
}
function getActivityDetail({ id, DMSCode = null, ShopCode = null }) {
  return axiosp.reqPost(`MallActivity/GetActivityDetails`, {
    id,
    DMSCode,
    ShopCode,
  });
}
/*********
 * 加入购物车
 * 参数名 | 描述 | 备注
 * -|-|-
 * list 集合
 * ProductId 产品id
 * Num  产品数量
 * MainProductId 主产品id(是主产品传0)
 * IsTyingProduct 是否搭售(是1、否0)
 * MallActivityManagementId 活动id
 * ShoppingCartType  购物车数据类型  0默认 1单个产品 2活动包
 *
 * ********* */
function addCar(data) {
  return axiosp.reqPost("ShoppingCart/Add", {
    list: JSON.stringify(data),
  });
}

/*********
 * 产品列表
 * 参数名 | 描述 | 备注
 * -|-|-
 * QueryProductEnum  查询产品类型 必填
 * BrandId  品牌id
 * ProductClassifyId 产品分类id
 * ProductName 产品名称
 * BrandManufacturerCode 产品厂商编码
 * Specifications 规格
 * Model 型号
 * VehicleTypeId 力扬车型id
 * IsClassify 是否查询产品分类多层级数据 目前只支持三层
 * pageSize 每页条目数
 * pageNo 页码  从 0 开始
 * WarehouseId 仓库ID
 *
 * ********* */
function getProduct({
  QueryProductEnum,
  RobotCode,
  BrandId,
  ProductClassifyId,
  ProductName,
  BrandManufacturerCode,
  Specifications,
  Model,
  VehicleTypeId,
  IsClassify,
  Vin,
  Keyword,
  pageSize,
  pageNo,
  WarehouseId
}) {
  return axiosp.reqPost("IntelligentRecognition/GetPcProductListBySearchNEW", {
    QueryProductEnum,
    RobotCode,
    ProductBrandIds: BrandId,
    ProductClassIds: ProductClassifyId,
    ProductName,
    BrandManufacturerCode,
    Specifications,
    Model,
    VehicleId: VehicleTypeId, //对于后台 VehicleId是id VehicleTypeId是code
    IsClassify,
    Vin,
    VinCode: Vin,
    Keyword,
    pageSize,
    pageNo,
    WarehouseId
  });
}

/*********
 * 产品列表
 * 参数名 | 描述 | 备注  
 * -|-|-
 * lQueryProductEnum  查询产品类型 必填
 * BrandId  品牌id
 * ProductClassifyId 产品分类id
 * ProductName 产品名称
 * BrandManufacturerCode 产品厂商编码
 * Specifications 规格
 * Model 型号
 * VehicleTypeId 力扬车型id
 * IsClassify 是否查询产品分类多层级数据 目前只支持三层
 * pageSize 每页条目数  
 * pageNo 页码  从 0 开始
 * 
 * ********* */
function getProductSearch({
  QueryProductEnum, 
  BrandId, 
  ProductClassifyId, 
  ProductName, 
  BrandManufacturerCode, 
  Specifications, 
  Model, 
  VehicleTypeId, 
  IsClassify, 
  pageSize, 
  pageNo,
  WarehouseId,
  RobotCode
}) {
  return axiosp.reqPost('Product/GetProductListNEW', {
    QueryProductEnum,
    BrandId,
    ProductClassifyId,
    ProductName,
    BrandManufacturerCode,
    Specifications,
    Model,
    VehicleTypeId,
    IsClassify,
    pageSize,
    pageNo,
    WarehouseId,
    RobotCode
  })
}

/*********
 * 参考数据
 * 参数名 | 描述 | 备注
 * -|-|-
 * QueryProductEnum  查询产品类型 必填
 * BrandId  品牌id
 * ProductClassifyId 产品分类id
 * ProductName 产品名称
 * BrandManufacturerCode 产品厂商编码
 * Specifications 规格
 * Model 型号
 * VehicleTypeId 力扬车型id
 * IsClassify 是否查询产品分类多层级数据 目前只支持三层
 * pageSize 每页条目数
 * pageNo 页码  从 0 开始
 * WarehouseId 仓库ID
 *
 * ********* */
function getReferenceData({
  QueryProductEnum,
  RobotCode,
  BrandId,
  ProductClassifyId,
  ProductName,
  BrandManufacturerCode,
  Specifications,
  Model,
  VehicleTypeId,
  IsClassify,
  Vin,
  Keyword,
  pageSize,
  pageNo,
  WarehouseId
}) {
  return axiosp.reqPost("IntelligentRecognition/GetPcRobotStaVehicleProduc", {
    QueryProductEnum,
    RobotCode,
    ProductBrandIds: BrandId,
    ProductClassIds: ProductClassifyId,
    ProductName,
    BrandManufacturerCode,
    Specifications,
    Model,
    VehicleId: VehicleTypeId, //对于后台 VehicleId是id VehicleTypeId是code
    IsClassify,
    Vin,
    VinCode: Vin,
    Keyword,
    pageSize,
    pageNo,
    WarehouseId
  });
}

/*********
 * 产品列表
 * 参数名 | 描述 | 备注
 * -|-|-
 * lQueryProductEnum  查询产品类型 必填
 * BrandId  品牌id
 * ProductClassifyId 产品分类id
 * ProductName 产品名称
 * BrandManufacturerCode 产品厂商编码
 * Specifications 规格
 * Model 型号
 * VehicleTypeId 力扬车型id
 * IsClassify 是否查询产品分类多层级数据 目前只支持三层
 * pageSize 每页条目数
 * pageNo 页码  从 0 开始
 *
 * ********* */
function getProductRaw({
  lQueryProductEnum,
  BrandId,
  ProductClassifyId,
  ProductName,
  BrandManufacturerCode,
  Specifications,
  Model,
  VehicleTypeId,
  IsClassify,
  pageSize,
  pageNo,
}) {
  return axiosp.reqPost("Product/GetProductList", {
    lQueryProductEnum,
    BrandId,
    ProductClassifyId,
    ProductName,
    BrandManufacturerCode,
    Specifications,
    Model,
    VehicleTypeId,
    IsClassify,
    pageSize,
    pageNo,
  });
}

/*********
 * 预收款详情（无商品秒杀）
 * 参数名 | 描述 | 备注
 * -|-|-
 * Id  参与的活动记录id 必填
 * ActivityType  活动类型
 *
 * ********* */
function GetActivitiesInvolvedDetails({ Id, ActivityType }) {
  return axiosp.reqPost("MallActivity/GetActivitiesInvolvedDetails", {
    Id,
    ActivityType,
  });
}

// 历史订单
function historicalOrder({
  SalesOrderID,
  ProductName,
  BrandManufacturerCode,
  Specifications,
  Model,
  CustomModel,
  StartTime,
  EndTime,
  SalesOrderCode,
  VehicleTypeId,
  pageNo,
}) {
  return axiosp.reqPost("IntelligentRecognition/GetSalesOrder", {
    SalesOrderID,
    ProductName,
    BrandManufacturerCode,
    Specifications,
    Model,
    CustomModel,
    StartTime,
    EndTime,
    SalesOrderCode,
    VehicleTypeId,
    pageNo,
  });
}

//可能返回
function GetSalesVehicle({ VehicleId }) {
  return axiosp.reqPost("/IntelligentRecognition/GetSalesVehicle", { VehicleId });
}

function GetRobotSelectRecord({ VehicleType, vin, StartTime, EndTime }) {
  return axiosp.reqPost("/IntelligentRecognition/GetRobotSelectRecord", { VehicleType, vin, StartTime, EndTime });
}

function GetProductSettingList() {
  return axiosp.reqPost('/Product/GetProductSettingList')
}

//检查是否可支付
async function checkCanPay({ OrderId, OrderType, ExtData }) {
  let checkStatus = false;

  if (OrderType == 20/** 结算 */) {
    let result = await getXSJDetail({ OrderId });
    if (result && result.Data) {
      result = result.Data;
      if (result.Status == 101 /** 保存 */) {
        checkStatus = true;
      } else if (result.Status == 103 /** 保存 */ && result.IsCashOnDelivery == 1 /** 是货到付款 */) {
        checkStatus = true;
      }
    }
  } else if (OrderType == 43/** 开单 */) {
    let result = await getXSKDetail({ OrderId });
    if (result && result.Data) {
      result = result.Data;
      if (result.Status == 201 /** 待审核 */) {
        checkStatus = true;
      }
    }
  } else if (OrderType == 64 /** 对账还款 */) {
    let result = await CreatePaymentHistory({ Ids: ExtData });
    if (result && result.Data) {
      result = result.Data;
      if (result.Id > 0 /** 成功生成支付单ID */) {
        checkStatus = true;
      }
    }
  } else {
    //不做判断
    checkStatus = true;
  }
  console.log("checkCanPay", { OrderId, OrderType }, checkStatus);
  return checkStatus;
}

//获取销售开单详情
function getXSKDetail({ OrderId }) {
  return axiosp.reqPost("Order/GetUntreatedOrderDetails", {
    OrderId,
    UserId: util.getStoObj('allinfo').ADS_UserId,
    //IsOnlineOrder: true,
  });
}

//第三方支付锁单
function OrderPayLock({ OrderId, OrderType }) {
  return axiosp.reqPost("Order/OrderPayLock", {
    OrderId,
    OrderType
  });
}

//第三方支付解锁单
function OrderPayLockUn({ OrderId, OrderType }) {
  return axiosp.reqPost("Order/OrderPayLockUn", {
    OrderId,
    OrderType
  });
}

//获取支付方式
function getPayType({Platform}) {
  return axiosp.reqPost("/ReceivablesItem/GetPaymentMethodPaymentConfiguration", {
    Platform
  });
}
//获取销售结算单详情
function getXSJDetail({ OrderId }) {
  return axiosp.reqPost("Order/GetSaleBillingDetails", {
    OrderId,
    UserId:util.getStoObj('allinfo').UserId,
    IsOnlineOrder: true,
  });
}
//是否显示仓库选择 data：1显示默认仓库库存,2不显示库存，3允许仓库选择，4显示所有仓库库存合计
function isWarehouseShow() {
  return axiosp.reqPost("/User/GetQuoteRobotInventoryDisplayType", {});
}

//获取仓库列表
function warehouseList() {
  return axiosp.reqPost("/User/GetWarehouse", {});
}

//首页是否显示仓库，仓库列表接口合并
function isWarehouseNew() {
  return axiosp.reqPost("/IntelligentRecognition/GetHomePageData", {});
}

/*******
 * 获取客户列表
 * OrgId	组织id	int
 * pageSize	条数	int
 * pageNo	页面	int
 *******/
function getCustomerList({ OrgId, pageSize, pageNo, keyWord }) {
  return axiosp.reqPost("IntelligentRecognition/GetCustomerList", {
    OrgId,
    pageSize,
    pageNo,
    keyWord
  });
}
/*******
 * 获取组织列表
 *******/
function getOrgList() {
  return axiosp.reqPost("IntelligentRecognition/GetOrg");
}
/*******
 * 根据客户Id获取客户是否预期欠款
 *******/
function getIsCustomerOverdueArrears({ CustomerId }) {
  return axiosp.reqPost("IntelligentRecognition/GetIsCustomerOverdueArrears",{
    CustomerId
  });
}
//是否可以出库
function GetIsWarehouseOut({ Type, ObjId }) {
  return axiosp.reqPost("Order/GetIsWarehouseOut", {
    Type,
    ObjId
  },false,false);
}
//出库
function GetStoreOutOrIn({ Type, IsReturnQuota, OrgId, list }) {
  return axiosp.reqPost("Order/GetStoreOutOrIn", {
    Type,
    IsReturnQuota,
    OrgId,
    list
  });
}
// 通过数据通查询VIN车型
function GetVehicleTypeInfoBySJT(VinCode){
  return axiosp.reqPost('ApiCarTypeClass/GetVinCarList', {
    VinCode
  },false,false)
}
export default {
  GetCredit,
  getDMSCode,
  getMobile,
  getShopCode,
  loginQPT,
  VerifyCustomerAuditStatus,
  getImgUrl,
  Eshop_login,
  GetErpDomainNameAll,
  PayMoney,
  CreatOrder,
  PayCredit,
  getOrderDetail,
  getActivity,
  getActivityDetail,
  addCar,
  getProduct,
  getProductRaw,
  getReferenceData,
  CreateVirtualAdvanceCollection,
  GetActivitiesInvolvedDetails,
  historicalOrder,
  GetSalesVehicle,
  GetRobotSelectRecord,
  checkCanPay,
  getXSKDetail,
  OrderPayLock,
  OrderPayLockUn,
  getPayType,
  isWarehouseShow,
  warehouseList,
  isWarehouseNew,
  GetProductSettingList,
  getCustomerList,
  getOrgList,
  getIsCustomerOverdueArrears,
  getProductSearch,
  GetIsWarehouseOut,
  GetStoreOutOrIn,
  GetVehicleTypeInfoBySJT
};
